// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var LanguageSelector$ReactHooksTemplate = require("./LanguageSelector.res.js");
var LanguageSelectorPosition$ReactHooksTemplate = require("./LanguageSelectorPosition.res.js");

function SurveyPageLanguageSlot(props) {
  var surveyLanguages = props.surveyLanguages;
  var position = props.position;
  if (!LanguageSelectorPosition$ReactHooksTemplate.shouldShowSelector(surveyLanguages, position)) {
    return null;
  }
  if (!LanguageSelectorPosition$ReactHooksTemplate.matchesSlot(position, props.expectedSlot)) {
    return null;
  }
  var wrapperClass = LanguageSelectorPosition$ReactHooksTemplate.wrapperClasses(position, props.containerWidth);
  var selectWidth = LanguageSelectorPosition$ReactHooksTemplate.selectWidthClass(position);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(LanguageSelector$ReactHooksTemplate.make, {
                    surveyLanguages: surveyLanguages,
                    languageSelected: props.languageSelected,
                    onLanguageChange: props.onLanguageChange,
                    client: props.client,
                    selectWidthClass: selectWidth
                  }),
              className: wrapperClass
            });
}

var make = SurveyPageLanguageSlot;

exports.make = make;
/* react/jsx-runtime Not a pure module */
